import React, { useState } from 'react';
import {
  getInterventionDisplayLines,
  getInterventionPhaseUiKey,
  effectiveMoyensRequired,
  type InstanceRow,
} from '../components/interventions/instanceModel';

/** Panneau contextuel à onglets — `.col-context` du prototype (Détail / Engins / Radio / Bilan). */

type Tab = 'detail' | 'engins' | 'radio' | 'bilan';

interface Props {
  intervention: InstanceRow | null;
  vehicleCount: number;
  renderRadio: (instanceId: number) => React.ReactNode;
}

const Field: React.FC<{ k: string; v: React.ReactNode }> = ({ k, v }) => (
  <div className="dfield">
    <span className="dfield__k">{k}</span>
    <span className="dfield__v">{v}</span>
  </div>
);

const ContextPanel: React.FC<Props> = ({ intervention, vehicleCount, renderRadio }) => {
  const [tab, setTab] = useState<Tab>('detail');

  const empty = (msg: string) => <div className="empty">{msg}</div>;

  const detail = () => {
    if (!intervention) return empty('Sélectionnez une intervention dans la file pour afficher son dossier complet.');
    const lines = getInterventionDisplayLines(intervention, 'Intervention');
    const phase = getInterventionPhaseUiKey(intervention);
    const p = Number(intervention.priorite ?? 3);
    const need = effectiveMoyensRequired(intervention) || 1;
    const phaseLab = phase === 'wait' ? 'En attente de moyens' : phase === 'travel' ? 'Moyens en transit' : phase === 'site' ? 'Sur les lieux' : 'En cours';
    return (
      <div className="block">
        <div className="block__h">
          Dossier {intervention.numero_intervention || intervention.id}
          <span className={`icard__prio p${p}`} style={{ marginLeft: 8 }}>P{p}</span>
        </div>
        <div className="dfront">
          <div className="dfront__title">{lines.headline}</div>
          <div className="dfront__addr">{lines.subline || 'Adresse non précisée'}</div>
        </div>
        <Field k="Appel reçu" v={intervention.date_creation ? new Date(intervention.date_creation).toLocaleTimeString('fr-FR') : '—'} />
        <Field k="Statut" v={intervention.statut || '—'} />
        <Field k="Phase" v={phaseLab} />
        <Field k="Moyens préconisés" v={`${need}`} />
        <Field k="Latitude / Longitude" v={`${Number(intervention.latitude || 0).toFixed(3)} / ${Number(intervention.longitude || 0).toFixed(3)}`} />
      </div>
    );
  };

  return (
    <aside className="panel col-context">
      <div className="panel__head panel__head--tabs">
        <div className="tabs">
          <button className={tab === 'detail' ? 'is-active' : ''} onClick={() => setTab('detail')}>Détail</button>
          <button className={tab === 'engins' ? 'is-active' : ''} onClick={() => setTab('engins')}>Engins</button>
          <button className={tab === 'radio' ? 'is-active' : ''} onClick={() => setTab('radio')}>Radio</button>
          <button className={tab === 'bilan' ? 'is-active' : ''} onClick={() => setTab('bilan')}>Bilan</button>
        </div>
      </div>
      <div className="panel__body scroll">
        {tab === 'detail' && detail()}
        {tab === 'engins' && (intervention ? empty('Engins engagés — port en cours.') : empty('Sélectionnez une intervention.'))}
        {tab === 'radio' && (intervention ? renderRadio(intervention.id) : empty('Sélectionnez une intervention pour voir son journal radio.'))}
        {tab === 'bilan' && (intervention ? empty('Bilan victimes — port en cours.') : empty('Sélectionnez une intervention.'))}
      </div>
      <div style={{ display: 'none' }}>{vehicleCount}</div>
    </aside>
  );
};

export default ContextPanel;
